{
    "filter": {
        "placeholder": {
            "legal_name": "Filter by organization name",
            "registration_number": "Filter by registration number",
            "business_name": "Filter by partner ID",
            "ports": "Filter by ports"
        }
    },
    "keys": {
        "registration_number": "CRN",
        "uuid": "Partner ID",
        "ports": "Ports",
        "legal_name": "Organization name"
    }
}